export default __webpack_public_path__ + "static/recent-postcard-1-c65de57ddfa670c4f2c132028ca4d5d4.jpeg";